// src/data/cardsData.js

import projetos from "../assets/images/projects.png";
import atualidade from "../assets/images/atualidades.png";
import promocoes from "../assets/images/sobre.png";
import localizacao from "../assets/images/location.png";

export const cards = [
    {
      icon: "",
      title: "Projetos",
      description: "Descrição sobre projetos e suas vantagens.",
      imgSrc: projetos,
      link: "/projects", // Caminho para a página de Projetos
    },
    {
      icon: "",
      title: "Produtos",
      description: "Confira nossos produtos disponíveis.",
      imgSrc: atualidade,
      link: "/products", // Caminho para a página de Atualidades
    },
    {
      icon: "",
      title: "Sobre Nós",
      description: "Integridade, Responsabilidade Social e Ambiental. Saiba mais sobre nós!",
      imgSrc: promocoes,
      link: "/about", // Caminho para a página de Promoções
    },
    {
      icon: "",
      title: "Fale Conosco",
      description: "Saiba onde nos encontrar em suas proximidades.",
      imgSrc: localizacao,
      link: "/contact", // Caminho para a página de Contato
    },
  ];
  